// src/plugins/sdk/useToast.ts — gated on `ui:toast`. Thin wrapper around the app's ToastProvider.
import { useToast as useAppToast } from '../../ui/Toaster';
import { usePluginId } from './PluginContext';
import { requirePermission } from '../permissions';
export function useToast() {
    const pluginId = usePluginId();
    const { notify } = useAppToast();
    return {
        info(body) { requirePermission(pluginId, 'ui:toast'); notify('info', body); },
        success(body) { requirePermission(pluginId, 'ui:toast'); notify('success', body); },
        error(body) { requirePermission(pluginId, 'ui:toast'); notify('error', body); },
    };
}
